import { ISelectModel } from 'common/models';
import API from 'services/api';

export const getAllRenterUnits = (propertyId?: string | null): Promise<ISelectModel<string>[]> => {
  return API.get(`/api/renter/accommodation/properties/${propertyId}/units/all`).then(
    response => response?.data,
  );
};
